// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1b-BQ","inputWrap":"styles_inputWrap__1RIQh","input":"styles_input__10w1i"};